import React, { useState, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import useForm from 'react-hook-form';
import Loader from '../common/loader';
import Breadcrumb from '../common/breadcrumb';
import { toast } from 'react-toastify';
import api from '../../config/axios';
import utils from '../../utils/miscUtils';
import { useStateValue } from '../../store';

const { makePasswordRandom } = utils;

const NewClient = withRouter(({ history }) => {
    const { handleSubmit, register, errors, setValue, getValues } = useForm();
    const [state, setState] = useState({
        loading: false,
        stepLoading: 1,
        resolved: false,
        data: null,
        error: null,
    });
    const [loaded, setLoaded] = useState(false);
    const [settings, setSettings] = useState(null);
    const [{ auth }] = useStateValue();
    const { franchiseId } = auth.user;
    const [map, setMap] = useState(null);
    const [bottleImage, setBottleImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    // Fetchs info when component is mounted
    useEffect(() => {
        //register({ name: 'location' }, { required: true });
        Promise.all([fetchSettings(franchiseId)]).then((values) => {
            setSettings(values[0]);
            setLoaded(true);

            // Ask for geolocation permit
            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                if (result.state === 'granted') {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition((position, error, options) => {
                            if (position) {
                                initGoogleMap(position.coords.latitude, position.coords.longitude);
                            } else {
                                initGoogleMap(
                                    values[0][0].referencePoint.coordinates[1],
                                    values[0][0].referencePoint.coordinates[0],
                                );
                            }
                        });
                    } else {
                        initGoogleMap(
                            values[0][0].referencePoint.coordinates[1],
                            values[0][0].referencePoint.coordinates[0],
                        );
                    }
                } else if (result.state === 'prompt') {
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition((position, error, options) => {
                            if (position) {
                                initGoogleMap(position.coords.latitude, position.coords.longitude);
                            } else {
                                initGoogleMap(
                                    values[0][0].referencePoint.coordinates[1],
                                    values[0][0].referencePoint.coordinates[0],
                                );
                            }
                        });
                    } else {
                        initGoogleMap(
                            values[0][0].referencePoint.coordinates[1],
                            values[0][0].referencePoint.coordinates[0],
                        );
                    }
                } else {
                    initGoogleMap(
                        values[0][0].referencePoint.coordinates[1],
                        values[0][0].referencePoint.coordinates[0],
                    );
                }
            });
        });
    }, []);

    const initGoogleMap = (lat, lng) => {
        let map = new window.google.maps.Map(document.getElementById(`map`), {
            center: {
                lat: lat,
                lng: lng,
            },
            zoom: 17,
            mapTypeControl: false,
            streetViewControl: false,
        });
        const marker = new window.google.maps.Marker({
            position: {
                lat: lat,
                lng: lng,
            },
            map,
        });

        map.addListener('center_changed', () => {
            var newLatLng = new window.google.maps.LatLng(map.center.lat(), map.center.lng());

            marker.setPosition(newLatLng);
        });
        setMap(map);
    };

    const fetchSettings = async () => {
        // consulta los settings dependiendo del usuario logueado
        // si está logueado un usuario FRANQUICIA trae sólo los settings de ese usuario
        // si está logueado un usuario ADMIN trae todos los settings de la DB

        let url = !!franchiseId ? `/franchise/${franchiseId}/settings` : '/settings';
        const { data } = await api.get(url);
        const settings = data.data;

        return settings;
    };

    const compressAndUpload = async (file, clientId, street1) => {
        // Comprimir
        const compressedBlob = await compressImage(file);

        // Convertir Blob a Buffer/ArrayBuffer para S3
        const arrayBuffer = await compressedBlob.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        // Subir a S3
        const imageUrl = await handleImageS3(file, buffer, clientId, street1);
        return imageUrl;
    };

    const compressImage = async (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Redimensionar manteniendo proporción
                const maxWidth = 700;
                const ratio = maxWidth / img.width;
                canvas.width = maxWidth;
                canvas.height = img.height * ratio;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Comprimir a JPEG
                canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    'image/jpg',
                    0.8,
                );
            };
        });
    };

    /**
     * Handle request of signed URL and upload procces of files to AWS S3
     * @param {Object} data Information about category (name, image, src)
     * @return {String} URL to store in DB
     */
    const handleImageS3 = async (file, buffer, idCliente, nameAddress) => {
        const addressTrimmed = nameAddress.split(' ')[0];
        const fileName = `${idCliente}-${addressTrimmed}.${file.type.split('/')[1]}`;
        const fileType = file.type;
        const requestSigning = {
            fileName,
            fileType,
        };

        // request signedurl to AWS
        const responseAWS = await api.post('/aws/request-url-signed', requestSigning);
        const { signedRequest, url } = responseAWS.data.data;

        // upload image directly to S3 bucket
        try {
            await axios({
                url: signedRequest,
                method: 'PUT',
                data: buffer,
                headers: {
                    'Content-Type': fileType,
                },
            });
            return url;
        } catch (e) {
            console.log(e);
        }
    };

    const handleNewClient = async (data) => {
        const dataClient = {
            ...data,
            phone_number: Number(data.phone_number.replace('0', '58')), //.replace() in javascript only replaces the first occurrence by default
            auth_type: 'local',
            password: makePasswordRandom(),
            requestSource: 'admin',
        };
        setState({
            ...state,
            loading: true,
        });
        api.post('/client/signup', dataClient)
            .then(async (response) => {
                setState({
                    ...state,
                    stepLoading: 2,
                });

                const clientId = response.data.data.client.id;

                // upload image to s3
                let imageUrl = null;

                if (bottleImage) {
                    imageUrl = await compressAndUpload(bottleImage, clientId, data.street1);
                }
                const dataAddress = {
                    street1: data.street1,
                    street2: data.street2,
                    house_number: 'N/A',
                    latitude: map?.center.lat(),
                    longitude: map?.center.lng(),
                    observation: data.observation,
                    photoBottle: imageUrl,
                };

                api.post(`/client/${clientId}/address`, dataAddress)
                    .then(() => {
                        toast.success('Cliente agregado con éxito');
                        history.push(`/clientes/${clientId}`);
                        setState({
                            ...state,
                            loading: false,
                            resolved: true,
                        });
                    })
                    .catch((error) => {
                        toast.error('Hubo un error al agregar la dirección. Intente de nuevo');
                        setState({
                            ...state,
                            loading: false,
                            error: error,
                        });
                    });
            })
            .catch((error) => {
                if (error.response && error.response.status === 409) {
                    toast.error(error.response.data.errors[0].msg);
                    setState({
                        ...state,
                        loading: false,
                    });
                    return;
                }
                toast.error('Hubo un error al agregar el cliente. Intente de nuevo');
                setState({
                    ...state,
                    loading: false,
                });
            });
    };

    const handleBottleImageChange = (e) => {
        const file = e.target.files[0];
        setBottleImage(file);
        setImagePreview(URL.createObjectURL(file));
    };

    if (!loaded)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );

    return (
        <Fragment>
            <Breadcrumb title="Nuevo Cliente" parent={null} />
            {state.loading && (
                <div
                    style={{
                        display: 'flex',
                        height: '50vh',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Loader />
                    <h3>Cargando</h3>
                    {state.stepLoading === 1 && <p>Guardando Cliente</p>}
                    {state.stepLoading === 2 && <p>Guardando Dirección</p>}
                </div>
            )}
            <div
                className="container-fluid form-client"
                style={{ display: state.loading ? 'none' : 'block' }}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row product-adding">
                                    <div className="col-xl-10 offset-xl-1">
                                        <div className="needs-validation add-product-form mt-0">
                                            <div className="form form-label-center">
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="name"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-user" /> Nombre Completo
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="name"
                                                            placeholder="Pedro Perez"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                        />
                                                        {errors.name &&
                                                            errors.name.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Nombre es obligatorio
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="name"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-phone" /> Teléfono
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="04147353821"
                                                            name="phone_number"
                                                            inputMode="numeric"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                        />
                                                        {errors.phone_number &&
                                                            errors.phone_number.type ===
                                                                'required' && (
                                                                <p className="message-error-input">
                                                                    Teléfono es obligatorio
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="email"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-envelope" /> Email
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="romer@ejemplo.com"
                                                            name="email"
                                                            ref={register({
                                                                required: true,
                                                                pattern:
                                                                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i,
                                                            })}
                                                        />
                                                        {errors.email &&
                                                            errors.email.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Email es obligatorio
                                                                </p>
                                                            )}
                                                        {errors.email &&
                                                            errors.email.type === 'pattern' && (
                                                                <p className="message-error-input">
                                                                    Email incorrecto. Debe ingresar
                                                                    un tipo de email adecuado
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row product-adding">
                                    <div className="col-xl-10 offset-xl-1">
                                        <div className="needs-validation add-product-form mt-0">
                                            <div className="form form-label-center">
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="street1"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-map-pin" /> Dirección de
                                                        entrega
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="street1"
                                                            className="form-control"
                                                            placeholder="Sector, avenida, calle, carrera"
                                                            name="street1"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                        />
                                                        {errors.street1 &&
                                                            errors.street1.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Dirección obligatoria
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="street2"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-building" /> Edificio,
                                                        casa
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="street2"
                                                            className="form-control"
                                                            placeholder="Número de casa, edificio, piso, apto"
                                                            name="street2"
                                                            ref={register({
                                                                required: true,
                                                            })}
                                                        />
                                                        {errors.street2 &&
                                                            errors.street2.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Este campo es obligatorio
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>

                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="email"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-map-marker" /> GPS:
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: 300,
                                                            }}
                                                            id="map"
                                                        />
                                                        {errors.location &&
                                                            errors.location.type === 'required' && (
                                                                <p className="message-error-input">
                                                                    Ubicación GPS es obligatoria
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>
                                                <br />
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="observation"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        Tipo de envase
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="observation"
                                                            className="form-control"
                                                            placeholder="Tipo A, B, C"
                                                            name="observation"
                                                            ref={register({
                                                                required: false,
                                                            })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group mb-3 row">
                                                    <label
                                                        htmlFor="photoBottle"
                                                        className="col-xl-3 col-sm-4 mb-0 label-inputs-form"
                                                    >
                                                        <i className="fa fa-camera" /> Foto del
                                                        botellón
                                                    </label>
                                                    <div className="col-xl-6 col-sm-7">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name="photoBottle"
                                                            accept="image/*"
                                                            onChange={handleBottleImageChange}
                                                        />
                                                        {imagePreview && (
                                                            <div
                                                                style={{
                                                                    marginTop: 10,
                                                                    display: 'flex',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    src={imagePreview}
                                                                    alt="Preview"
                                                                    style={{
                                                                        maxWidth: 200,
                                                                        maxHeight: 200,
                                                                        borderRadius: 8,
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 text-center mt-5 mb-3">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={handleSubmit(handleNewClient)}
                                    >
                                        Guardar usuario
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default NewClient;
